<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.search-duotone"></svg-vue>
          <h1 class="content-title">
            {{ $t('Track repair order') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-purple" to="/workshop">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body p-5">
        <track-repair />
      </div>
    </div>
  </main>
</template>
<script>
import TrackRepair from '@/views/pages/repair/repair-track';
export default {
  name: 'index',
  components: { TrackRepair },
};
</script>
